export default __webpack_public_path__ + "static/media/wave.dee64875.png";